import { Extension } from '@tiptap/core';
import { Plugin } from '@tiptap/pm/state';

export interface InsertOnlyGuardOptions {
  isInsertOnlyMode: boolean;
}

export const InsertOnlyGuard = Extension.create<InsertOnlyGuardOptions>({
  name: 'insertOnlyGuard',

  addOptions() {
    return {
      isInsertOnlyMode: false,
    };
  },

  addStorage() {
    return {
      enabled: this.options.isInsertOnlyMode,
    };
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        filterTransaction: (tr) => {
          if (!this.storage.enabled) {
            return true;
          }
          const uiEvent = tr.getMeta('uiEvent') as string | undefined;

          if (uiEvent === 'input' || uiEvent === 'paste' || uiEvent === 'cut') {
            return false;
          }

          return true;
        },
        props: {
          handleTextInput: () => (this.storage.enabled ? true : false),
          handlePaste: () => (this.storage.enabled ? true : false),

          // ✅ allow native drag & drop
          handleDrop: () => false,

          handleKeyDown: (_view, event) => {
            if (!this.storage.enabled) {
              return false;
            }
            const destructiveKeys = ['Backspace', 'Delete', 'Enter', 'Tab'];

            if (destructiveKeys.includes(event.key)) {
              return true;
            }
            if (event.key.length === 1) {
              return true;
            }

            return false;
          },

          handleDOMEvents: {
            beforeinput: (_view, ev) => {
              if (!this.storage.enabled) {
                return false;
              }
              const e = ev as InputEvent;
              const t = e.inputType || '';

              if (
                t.startsWith('insert') ||
                t.startsWith('delete') ||
                t === 'insertCompositionText'
              ) {
                e.preventDefault();

                return true;
              }

              return false;
            },
            compositionstart: () => (this.storage.enabled ? true : false),
            compositionupdate: () => (this.storage.enabled ? true : false),
            compositionend: () => (this.storage.enabled ? true : false),
          },
        },
      }),
    ];
  },
});
